import { render } from "./CreditsHistory.vue?vue&type=template&id=30a8d446"
import script from "./CreditsHistory.vue?vue&type=script&lang=js"
export * from "./CreditsHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__